import { Component } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';
import { MatDialog } from '@angular/material/dialog';
import { MediaRoomVersionDetailModalComponent } from './mediaroom-version-detail-modal.component';

@Component({
  selector: 'app-mediaroom-registry-list',
  templateUrl: './mediaroom-registry-list.component.html',
  styleUrls: ['./mediaroom-registry-list.component.css'],
})
export class MediaRoomRegistryListComponent {
  url: string = 'mediaRoomRegistries';
  data: Array<any> = [];
  searchText = '';
  filteredData: Array<any> = [];
  searchSuggestions: string[] = [];
  currentPage: number = 1;
  morePages: boolean = true;
  itemsPerPage: number = 50;
  viewMode: string = 'all'; // 'all', 'review', 'refresh_due', 'approved_ready'

  modalTitle: string = '';
  modalContent: string | null = null;

  // Filters
  filters = {
    status: '',
    pack_type: '',
    vertical: '',
    consumer_targets: '',
    approved_by: '',
    refresh_due: false,
  };

  resumenCards = [
    {
      label: '',
      value: '',
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '',
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '',
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '',
      icon: 'fas fa-globe', // Consider using a different icon if available
      bgClass: 'bg-white',
      desc: 'MEDIAROOM',
      route: '/marketing/mediaroomRegistry',
    },
    
  ];

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  switchView(mode: string): void {
    this.viewMode = mode;
    this.currentPage = 1;
    this.getData();
  }

  getData(): void {
    let queryParams = `?page=${this.currentPage}&limit=${this.itemsPerPage}&search=${this.searchText}`;

    // Add view mode specific filters
    if (this.viewMode === 'review') {
      queryParams += `&status=review`;
    } else if (this.viewMode === 'refresh_due') {
      queryParams += `&refresh_due=true`;
    } else if (this.viewMode === 'approved_ready') {
      queryParams += `&status=approved`;
    }

    // Add manual filters
    if (this.filters.status && this.viewMode === 'all')
      queryParams += `&status=${this.filters.status}`;
    if (this.filters.pack_type)
      queryParams += `&pack_type=${this.filters.pack_type}`;
    if (this.filters.vertical)
      queryParams += `&vertical=${this.filters.vertical}`;
    if (this.filters.consumer_targets)
      queryParams += `&consumer_targets=${this.filters.consumer_targets}`;
    if (this.filters.approved_by)
      queryParams += `&approved_by=${this.filters.approved_by}`;
    if (this.filters.refresh_due) queryParams += `&refresh_due=true`;

    this.dataService
      .getData(`${this.url}${queryParams}`)
      .subscribe((response) => {
        if (response && response.data) {
          this.data = response.data;
          this.filteredData = [...this.data];
          this.updateSuggestions();
        }
      });
  }

  applyFilters(): void {
    this.currentPage = 1;
    this.getData();
  }

  resetFilters(): void {
    this.filters = {
      status: '',
      pack_type: '',
      vertical: '',
      consumer_targets: '',
      approved_by: '',
      refresh_due: false,
    };
    this.applyFilters();
  }

  approveItem(id: string): void {
    const approved_by = prompt('Ingrese el nombre del aprobador:', 'Admin');
    if (!approved_by) return;

    this.dataService
      .putData(`${this.url}/${id}/approve`, { approved_by })
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  updateItemStatus(id: string, status: string): void {
    this.dataService
      .putData(`${this.url}/${id}/status`, { status })
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  deleteData(id: string): void {
    if (!confirm('¿Desea eliminar el registro?')) {
      return;
    }

    this.dataService
      .deleteData(`${this.url}/delete/${id}`)
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  retryGeneration(id: string): void {
    if (!confirm('¿Desea reintentar la generación?')) return;

    this.dataService
      .putData(`${this.url}/${id}/retry-generation`, {})
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  filter() {
    const texto = this.searchText.trim().toLowerCase();
    if (!texto) {
      this.filteredData = [...this.data];
    } else {
      this.filteredData = this.data.filter((item) => {
        return (
          (item.title && item.title.toLowerCase().includes(texto)) ||
          (item.content_id && item.content_id.toLowerCase().includes(texto))
        );
      });
    }
  }

  updateSuggestions() {
    const sugerenciasSet = new Set<string>();
    this.data.forEach((item) => {
      if (item.title) sugerenciasSet.add(item.title);
      if (item.content_id) sugerenciasSet.add(item.content_id);
    });
    this.searchSuggestions = Array.from(sugerenciasSet).filter(Boolean);
  }

  openVersionDetail(version: any): void {
    if (!version) return;

    this.dialog.open(MediaRoomVersionDetailModalComponent, {
      width: '800px',
      data: { version },
    });
  }

  showModal(title: string, content: string) {
    this.modalTitle = title;
    this.modalContent = content;
  }

  closeModal() {
    this.modalContent = null;
  }
}
